module.exports = __webpack_public_path__ + "media/one-place.50e8c39d.mp4";